import { render, staticRenderFns } from "./UnavailableDatatable.vue?vue&type=template&id=52c156d0"
import script from "./UnavailableDatatable.vue?vue&type=script&lang=js"
export * from "./UnavailableDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports